import React, { useState } from "react";
import List from "../mermaPartList";
import Filter from "../mermaPartFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import * as MermaPartService from "../../../../services/MermaPartService";
import moment from "moment-timezone";
import * as XLSX from "xlsx";

const queryClient = new QueryClient();

const MermaPartFilterListContainer = () => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.mermaPart.title") },
  ];

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const exportToExcel = async () => {
    const filter = {
      filters,
      sort: "initTime",
    };
    MermaPartService.listToExport(filter).then((result) => {
      const data = result.map((item) => {
        return {
          A: moment(item.initTime).format("DD-MM-yyyy"),
          B: item.code.article.name,
          C: item.code.article.code,
          D: item.code.location.name,
          E: item.code.sector ? item.code.sector.name : "-",
          F: item.code.batch.code,
          G: item.code.variety.culture,
          H: item.code.variety.name,
          I: item.numPlants,
          J: item.comments,
        };
      });

      data.unshift({
        A: "Fecha del parte",
        B: "Nombre Artículo",
        C: "Código artículo",
        D: "Ubicación",
        E: "Sector",
        F: "Lote",
        G: "Cultura",
        H: "Variedad",
        I: "Cantidad",
        J: "Motivo",
      });
      const filename = `Merma_${moment(new Date()).format("DDMMyyyyHHmm")}`;
      const sheetName = "Partes de merma";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.mermaPart.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
          />
        </div>
      </div>
      <div className="row justify-content-center mt-4 no-margin">
        <div className="col-12 col-md-11 text-end">
          <button
            type="button"
            className="btn btn-md btn-secondary"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel icon-button"></i>{" "}
            {t("exportFileExcel")}
          </button>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
    </>
  );
};

MermaPartFilterListContainer.propTypes = {};

export default MermaPartFilterListContainer;
